import {z} from '@hono/zod-openapi';

export const vehicleServiceCampaignRequestSchema = z.object({vehicleId: z.string().uuid()});
export type VehicleServiceCampaignRequest = z.infer<typeof vehicleServiceCampaignRequestSchema>;
